import { useAskInputSourceSelection } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSourceSelection.js';
import { useGlobalAvailableSources } from '#pplx/frontend/apps/ask/hooks/shared-source-selection-hooks/useSharedSourceSelection.js';
import { useThreadSources } from '#pplx/frontend/apps/ask/hooks/shared-source-selection-hooks/useThreadSources.js';
export const useAskInputSources = ({ sources: controlledSources, onSourcesChange: setControlledSources, ...options }) => {
    const { sources: internalSources, setSources: internalSetSources } = useGlobalAvailableSources();
    const { lastResultSources } = useThreadSources();
    return useAskInputSourceSelection({
        ...options,
        sources: controlledSources ?? internalSources,
        onSourcesChange: setControlledSources ?? internalSetSources,
        initialSources: lastResultSources,
    });
};
//# sourceMappingURL=useAskInputSources.js.map